import { signupUrl } from './claimUrl.js'

/**
 * inviteClinicianMailto — the one "invite a clinician to Orella" e-mail (s123 DoctorsHomeKit text, moved here in s126 so
 * the office picker's "Invite to Orella" pill sends the same words; TestFlight build 92 note 8).
 */
export function inviteClinicianMailto() {
  const subject = 'Join Orella Health'
  const body = `Hi,\n\nI'd like to share my health case with you through Orella Health, a platform that streamlines patient intake and communication.\n\nClinicians can join Orella at: ${signupUrl()}\n\nThank you!`
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}
